// removed by extract-text-webpack-plugin
module.exports = {"CTANavigation":"CTANavigation","CTANavigation__container":"CTANavigation__container","CTANavigation__container__wrap":"CTANavigation__container__wrap","CTANavigation__container__wrap__list":"CTANavigation__container__wrap__list","CTANavigation__container__wrap__list__item":"CTANavigation__container__wrap__list__item","Cta__button__text":"Cta__button__text","open":"open","hasTouch":"hasTouch","CTANavigation__container__wrap__handle":"CTANavigation__container__wrap__handle"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/cta-navigation/styles.css
// module id = 867
// module chunks = 0 1